<template>
  <div>
    <section class="section"></section>
    <section class="section">
      <p class="title has-text-centered">Mini Viewer</p>
    </section>
    <div class="container is-mobile">
      <div class="field">
        <div class="field-body">
          <div class="field is-grouped">
            <div class="control is-expanded">
              <input
                class="input"
                type="text"
                placeholder="Coloca la url aqui"
                v-model="url"
              />
            </div>
            <div class="control">
              <button
                class="button is-white"
                @click="open_url"
                title="Ver video en otra ventana"
              >
                <fa-icon icon="external-link-alt" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import URL from "@/url.js"

export default {
  el: "#app",
  template: "#plantilla",

  data: function() {
    return {
      url: "",
      window_open_config: {
        directories: "no",
        titlebar: "no",
        toolbar: "no",
        location: "no",
        status: "no",
        menubar: "no",
        scrollbars: "no",
        resizable: "no"
      }
    };
  },

  computed: {

    url_embebed() {
      return URL.embebed(this.url);
    },

    new_window_config() {
      let config = "";
      let k;
      for (k in this.window_open_config) {
        config.concat(`${k}=${this.window_open_config[k]},`);
      }
      return config;
    }

  },

  methods: {

    open_url() {
      this.$log(this.new_window_config);
      this.$log(this.url_embebed, "_blank", this.new_window_config);
      window.open(this.url_embebed, "_blank", "location=0");
    }

  }
};
</script>
